"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMissingFields = void 0;
const models_1 = require("../../models");
/**
 * Checks for missing required fields based on the current step and form data
 * @param {Object} params.formData - The form data to validate
 * @param {number} params.step - The current step in the form process
 * @returns {string[]} Array of missing field descriptions
 */
const getMissingFields = (formData, step) => {
    const missing = [];
    // Step 1 validations
    if (step === 1) {
        // GOLF_HOTEL trip type validations
        if (formData?.trip?.type === models_1.TripType.GOLF_HOTEL) {
            const isAirportTransfer = formData?.transfers?.type === models_1.TransferType.GOLF_AIRPORT ||
                formData?.transfers?.type === models_1.TransferType.AIRPORT;
            if (isAirportTransfer) {
                // Check arrival airport
                if (formData?.transfers?.arrival_airport === null) {
                    missing.push("Arrival airport");
                }
                // Check departure airport if not returning to origin
                if (formData?.transfers?.return_to_origin_airport === false &&
                    formData?.transfers?.departure_airport === null) {
                    missing.push("Departure airport");
                }
            }
        }
        // GOLF trip type validations
        if (formData?.trip?.type === models_1.TripType.GOLF) {
            if (formData?.transfers?.type !== models_1.TransferType.NONE) {
                if (formData?.transfers?.primary_pickup_area === null) {
                    missing.push("Please select a primary pick-up/drop-off location");
                }
            }
        }
    }
    // Add more step validations as needed
    // if (step === 2) { ... }
    return missing;
};
exports.getMissingFields = getMissingFields;
